import Button from "@mui/material/Button";
import EmptyIcon from "../assets/empty.svg";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import React from "react";

const RequestAccess = () => {
    const [isOpen, setIsOpen] = React.useState(false);
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '840px',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };
    return (
        <div>
            <div>
                <img src={EmptyIcon}></img>
            </div>
            <div style={{ fontSize: '24px', fontWeight: '500', width: '420px', wordWrap: 'break-word', alignContent: 'center', placeSelf: 'anchor-center' }}>
                Access denied - but don't worry, we can help you get where you need to go.
            </div>
            <div style={{ alignContent: 'center', placeSelf: 'anchor-center' }}>
                <Button style={{ fontSize: '16px', fontWeight: '500', margin: '30px', width: '200px', height: '50px', backgroundColor: '#FD5107', textTransform: 'none' }} variant="contained" color="success" onClick={() => setIsOpen(true)}>Request Access</Button>
            </div>
            <Modal
                open={isOpen}
                onClose={() => setIsOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={modalStyle}>
                    For access to the NIS IdaaS Migration Portal, select OK. You will need to reach out to your PoD team, to check who is your PoD contact please click here <a href="https://migration.idaas.pwc.com/docs/introduction/#virtual-points-of-delivery-vpod">link</a>. <br/>If you are an application owner, please specify this in the email template displayed in the pop-up.<br/><br/>
                    <Button style={{ margin: '20px', float: 'right', width: '100px' }} variant="contained" color="info" onClick={() => setIsOpen(false)}>Close</Button>
                </Box>
            </Modal>
        </div>
    );
};

export default RequestAccess;